export default [
    {
        path: 'regularizacao-cadastro',
        component: () => import(
            /* webpackChunkName: 'pronto-atendimento-regularizacao-cadastro' */
            '@/views/pronto-atendimento/regularizacao-cadastro/Index'
        ),
        redirect: 'regularizacao-cadastro/index',
        children: [
            {
                name: 'pronto-atendimento-regularizacao-cadastro-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-regularizacao-cadastro' */
                    '@/views/pronto-atendimento/regularizacao-cadastro/List.vue'
                ),
            },
        ],
    },
]